import objectAssign from 'object-assign';
import Promise from 'promise-polyfill';
import 'url-search-params-polyfill';
if(typeof window!= 'undefined'){
  if (typeof Object.assign === 'undefined' || Object.assign === "undefined") {
    Object.assign = objectAssign;
  }
  if ( !window.Promise) {
    window.Promise = Promise;
  }
}


// WEBPACK FOOTER //
// ./src/objectAssignPolyfill.js